<script lang="ts">
	import type { EventInfo } from '../types';

	export let event: EventInfo;

	let eventVenueLine = event.venue;
	if (event.city) {
		eventVenueLine += `, ${event.city}`;
	}
	if (event.state) {
		eventVenueLine += `, ${event.state}`;
	}
</script>

<div class="bouttitle row mt-3 pt-3">
	<div class="col-12">
		<img class="float-end d-none d-md-block" height=50 src={event.promotion_logo} alt="promotion logo" />
		<h1>{event.name}</h1>
		<h3>
			{event.date?.toLocaleDateString('en-us', {
				day: 'numeric',
				year: 'numeric',
				month: 'short'
			})}, {eventVenueLine}
		</h3>
	</div>
</div>
